// Client-side mirror of packages/db/src/placeholder-email.ts - keep the two
// in step. Strava-only signups carry `strava-{id}@athlete.atlas.internal`
// until they add a real address; anonymised accounts carry
// `deleted+{id}@atlas.internal`. The route analyser's throwaway user
// (spec 27) carries `route-analyser+{uuid}@atlas.internal`; it lives only
// inside a rolled-back transaction, but is covered here in case one ever
// commits. Never display any of them as if it were real. The check is by
// domain, so every prefix above is covered.

export const PLACEHOLDER_EMAIL_DOMAINS = ["athlete.atlas.internal", "atlas.internal"] as const;

/** Local-part prefix of the route analyser's throwaway user email. */
export const ROUTE_ANALYSER_EMAIL_PREFIX = "route-analyser+";

export function isPlaceholderEmail(email: string | null | undefined): boolean {
  if (!email) return true;
  const at = email.lastIndexOf("@");
  if (at < 0) return true;
  const domain = email.slice(at + 1).toLowerCase();
  return (PLACEHOLDER_EMAIL_DOMAINS as readonly string[]).includes(domain);
}
